export default "__VITE_ASSET__3f6c12ab__"